import auth from './modules/auth';
import user from "./modules/role_user";
import permissions from './modules/permissions';
import platform from './modules/platform';
import orders from './modules/orders';
import customRequests from './modules/customRequests';
import invoices from './modules/invoices';
import modals from './modules/modals';
import recordsList from "@/store/modules/recordsList";
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    auth,
    permissions,
    platform,
    orders,
    customRequests,
    invoices,
    modals,
    recordsList,
  },
  // strict: debug,
});
